<template>
  <div id="app__ernest">
    <header class="app__header__ernest">
      <div>
        <u-icon>f</u-icon>
      </div>
      <div>
        <div><span>{{ $t('pages.questions.list.header.ernest') }}</span></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div></div>
    </header>

    <section class="app__section__ernest">
      <v-card>
        <v-card-title>
          {{ $t('pages.questions.list.header.name') }}
          <v-spacer/>
          <v-checkbox v-model="repoFilter"
                      :label="$t('pages.questions.list.header.filter')"/>
          <v-spacer/>
          <v-text-field
            v-model="search"
            append-icon="search"
            :label="$t('components.searchPlaceholder')"
            single-line
            hide-details
            color="valid"
          />
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="questionList"
          :search="search"
        >
          <template v-slot:item.label="{ item }">
            <router-link :to="modifUrl(item)"
                         v-if="isSelectedRepository(item.repositoryID)"
            >
              {{ item.label }}
            </router-link>
            <span class="text--disabled"
                  :title="getRepositoryLabel(item.repositoryID)"
                  v-else
            >{{ item.label }}</span>
          </template>

          <template v-slot:item.text="{ item }">
            <router-link :to="modifUrl(item)"
                         v-if="isSelectedRepository(item.repositoryID)">
              {{ getTruncatedText(item) }}
            </router-link>
            <span class="text--disabled"
                  :title="getRepositoryLabel(item.repositoryID)"
                  v-else
            >{{ getTruncatedText(item) }}</span>
          </template>

          <template v-slot:item.type="{ item }">
            {{ item.displayType }}
          </template>

          <template v-slot:item.updatedAt="{ item }">
            {{ getLocaleUpdatedAt(item.updatedAt) }}
          </template>

          <template v-slot:item.isActive="{ item }">
            <v-icon v-if="item.isActive">mdi-check</v-icon>
            <v-icon v-else>mdi-close</v-icon>
          </template>

          <template v-slot:item.actions="{ item }">
            <div class="table__actions__buttons" v-if="isSelectedRepository(item.repositoryID)">
              <router-link :to="cloneUrl(item)"
                           :title="$t('pages.questions.list.tooltip.duplicate')"
              >
                <div>
                  <u-icon>Ù</u-icon>
                </div>
              </router-link>
            </div>
          </template>

          <template v-slot:no-data>
            {{ $t('pages.questions.list.noData.name') }}
          </template>

          <template v-slot:no-results>
            {{ $t('pages.questions.list.noResult.name') }}
          </template>
        </v-data-table>
      </v-card>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'questionsList',
  data () {
    return {
      /**
       * Options de réglage pour le bouton d'ajout
       */
      addButton: {
        direction: 'right',
        fab: false,
        fling: false,
        hover: false,
        tabs: null,
        top: true,
        right: false,
        bottom: false,
        left: true,
        transition: 'scale-transition'
      },
      /**
       * Stocke la valeur du champ de recherche.
       */
      search: '',
      headers: [
        {
          text: this.$t('pages.questions.list.columns[0].name'),
          value: 'label'
        },
        {
          text: this.$t('pages.questions.list.columns[1].name'),
          value: 'text'
        },
        {
          text: this.$t('pages.questions.list.columns[2].name'),
          value: 'type'
        },
        {
          text: this.$t('pages.questions.list.columns[3].name'),
          value: 'updatedAt'
        },
        {
          text: this.$t('pages.questions.list.columns[4].name'),
          value: 'skillsNumber'
        },
        {
          text: this.$t('pages.questions.list.columns[5].name'),
          value: 'isActive'
        },
        {
          value: 'actions',
          sortable: false
        }
      ],
      repoFilter: true
    }
  },
  computed: {
    ...mapGetters('Questions', [
      'questions'
    ]),
    ...mapGetters('Repositories', ['repositorySelectedId', 'repositories']),
    questionList () {
      const filteredQuestions = this.repoFilter ? this.questions.filter(
        q => q.repositoryID ? q.repositoryID === this.repositorySelectedId : true
      ) : this.questions
      return filteredQuestions.map(q => this.updateType(q))
    }
  },
  async created () {
    await this.loadQuestions()
  },
  methods: {
    ...mapActions('Questions', [
      'loadQuestions'
    ]),
    cloneUrl: item => `/question/creation/${item.type}/${item.id}`,
    getTruncatedText (question) {
      let truncLength = 20
      let truncContinuation = '\u2026'
      return question.text.length < truncLength
        ? question.text
        : question.text.substring(0, truncLength) + truncContinuation
    },
    getLocaleUpdatedAt (updatedAt) {
      return new Date(updatedAt).toLocaleString(navigator.language)
    },
    isSelectedRepository (itemRepositoryId) {
      return itemRepositoryId ? this.repositorySelectedId === itemRepositoryId : true
    },
    getRepositoryLabel (itemRepositoryId) {
      const { name } = this.repositories.find(repository => repository.id === itemRepositoryId)
      return this.$t('pages.questions.list.tooltip.repository', { name })
    },
    modifUrl: item => `/question/modification/${item.type}/${item.id}`,
    updateType (question) {
      const type = (question.type === 'mcq' && question.isUnique)
        ? 'ucq' : question.type
      return {
        ...question,
        displayType: this.$t(`pages.questions.list.type.${type}.name`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/style/styleAppErnest";
  @import "../../assets/style/styleAppTableListErnest";

  #app__ernest {
    position: relative;
  }
</style>
